import React from "react";
import { useNavigate } from "react-router-dom";

export default function AttentionBanner(props) {
  
  // Navigation
  const navigate = useNavigate();
  return (
    <div className="container-fluid p-0 prep-new-trip">
      <div className="row app-container">
        <div
          className="col-12 p-0 main-cover"
          style={{ background: `url(${props.bgImg})` }}
        >
          {/* Banner Details Start */}
          <div className="col-xl-6 col-lg-7 col-md-10 col-12 start-prep-cover">
            <h2>{props.title}</h2>
            <p className="prep-new-trip-desc">{props.text}</p>
            <button onClick={() => {
              navigate("/all-places")
            }} 
            className="btn custom-btn rounded-pill">
              {props.btnText}
            </button>
          </div>
          {/* Banner Details End */}
        </div>
      </div>
    </div>
  );
}
